import { useState, useEffect, useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IdleTimer } from './IdleTimer';
import { APP_CONFIG } from '../config/settings';
import './IdleOverlay.css';

interface IdleOverlayProps {
  onRestart: () => void;
}

export function IdleOverlay({ onRestart }: IdleOverlayProps) {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  const resetTimeout = useCallback(() => {
    setIsVisible(false);

    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, APP_CONFIG.IDLE_TIMEOUT * 1000);

    return timeout;
  }, []);

  useEffect(() => {
    let timeout = resetTimeout();

    // Track user activity to reset the timeout
    const handleActivity = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = resetTimeout();
    };

    // Add event listeners for user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    events.forEach(event => {
      document.addEventListener(event, handleActivity, true);
    });

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      events.forEach(event => {
        document.removeEventListener(event, handleActivity, true);
      });
    };
  }, [resetTimeout]);

  const hideOverlay = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="idle-overlay" onClick={hideOverlay}>
      <h1>{t('resume')}</h1>
      <IdleTimer onTimeout={onRestart} />
    </div>
  );
}